import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, Mail, Youtube, Instagram } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { api } from "../lib/api";

export default function Footer() {
  const { settings } = useSettings();
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api
      .get("/courses")
      .then((r) => setFeatured(r.data.filter((c) => c.is_featured).slice(0, 5)))
      .catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0A0C0F] pt-16 pb-8 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-11 h-11 rounded-full bg-white flex items-center justify-center overflow-hidden">
                <img src="/aducation-logo.png" alt="Aducation" className="w-11 h-11 object-cover rounded-full" />
              </div>
              <div className="font-display font-extrabold text-xl text-white">Aducation</div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              India's Most Affordable Learning Platform. Empowering millions with quality Govt Job & Skills education.
            </p>
            <div className="flex gap-3 mt-5">
              <a href={`https://t.me/${settings.telegram_username}`} target="_blank" rel="noreferrer" data-testid="footer-telegram" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-amber-500/10 transition"><Send size={16} className="text-amber-400" /></a>
              <a href={`mailto:${settings.support_email}`} data-testid="footer-email" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-red-500/10 transition"><Mail size={16} className="text-red-400" /></a>
              {settings.youtube_url && (
                <a href={settings.youtube_url} target="_blank" rel="noreferrer" data-testid="footer-youtube" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-red-500/10 transition"><Youtube size={16} className="text-red-400" /></a>
              )}
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-amber-500/10 transition"><Instagram size={16} className="text-amber-400" /></a>
              )}
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">Quick Links</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-slate-400 hover:text-white transition">Home</Link></li>
              <li><Link to="/courses" className="text-slate-400 hover:text-white transition">All Courses</Link></li>
              <li><Link to="/about" className="text-slate-400 hover:text-white transition">About Us</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white transition">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">Popular Courses</div>
            <ul className="space-y-2.5 text-sm">
              {featured.length === 0 ? (
                <li className="text-slate-500 text-xs italic">Toggle "Featured on Home" in Admin → Courses to list here.</li>
              ) : (
                featured.map((c) => (
                  <li key={c.id}>
                    <Link
                      to={`/courses/${c.slug}`}
                      data-testid={`footer-course-${c.slug}`}
                      className="text-slate-400 hover:text-white transition line-clamp-1"
                    >
                      {c.title}
                    </Link>
                  </li>
                ))
              )}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">Get In Touch</div>
            <ul className="space-y-2.5 text-sm">
              <li><span className="text-slate-500">Telegram:</span> <a href={`https://t.me/${settings.telegram_username}`} className="text-slate-300 hover:text-amber-400" target="_blank" rel="noreferrer">@{settings.telegram_username}</a></li>
              <li><span className="text-slate-500">Email:</span> <a href={`mailto:${settings.support_email}`} className="text-slate-300 hover:text-red-400">{settings.support_email}</a></li>
              <li><span className="text-slate-500">Since:</span> <span className="text-slate-300">2022</span></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Aducation. All rights reserved.</p>
          <p className="text-xs text-slate-500">Made in India · <span className="gold-text font-semibold">India's Most Affordable Learning Platform</span></p>
        </div>
      </div>
    </footer>
  );
}
